/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Chat_4Inputs */



/**
* | output |
* | --- |
* | "Obaid's CRM shortlist" |
*
* @param {Sidebar_Preview_Chat_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_chat_4 = /** @type {((inputs?: Sidebar_Preview_Chat_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Chat_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Obaids CRM-Auswahl")
	return /** @type {LocalizedString} */ ("Obaid's CRM shortlist")
});